import API from 'services/api';

export interface IPaging {
  pageNo?: number;
  pageSize?: number;
  params?: any;
}

export const getPartnersSuppliers = ({ pageNo, pageSize, params }: IPaging) => {
  return API.get(`/api/partners/suppliers?PageNo=${pageNo}&PageSize=${pageSize}`, {
    params: params,
  }).then(response => response?.data);
};
